module.exports = __webpack_public_path__ + "static/img/cadrage_bg_4.8c0b90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cadrage_bg_4.jpg
// module id = DNv8
// module chunks = 1